import { useCallback, useState } from "react";
import { useSignal } from "@preact/signals-react";
import { layout as layoutExpenses } from "./ModelStatementExpenses";

import BoardTable from "componentsv2/table/BoardTable";
import Dialog from "componentsv2/modal/Dialog";
import Button from "componentsv2/button/Button";
import { CurrencyDollarIcon } from "components/Icons";
import { genStoreId } from "componentsv2/tools/functions";

import { useTable } from "storev2/tableStore";

const ViewExpenses = () => {
  const openModal = useSignal(false);
  const [expensesLayout, setExpensesLayout] = useState(null);
  const [hasStatement, setHasStatement] = useState(false);

  const handleOpen = useCallback(() => {
    const { getTable } = useTable.getState();

    const storeId = genStoreId("account.statement", null);
    const recCash = getTable(storeId);
    const recCashUp = recCash?.records?.find(
      (rec) => rec?.["journal."]?.kind === "cash",
    );

    if (recCashUp) {
      const { id, date, name } = recCashUp;
      setExpensesLayout(
        layoutExpenses({
          statementId: id,
          statementDate: date,
          name: name,
        }),
      );
      setHasStatement(true);
    } else {
      setExpensesLayout(null);
      setHasStatement(false);
    }

    openModal.value = true;
  }, []);

  return (
    <div>
      <Button
        onClick={handleOpen}
        style="flex justify-start items-center shadow-md py-2 px-3 border !rounded-lg hover:bg-neutral-300 active:scale-95 cursor-pointer bg-white w-full h-full md:text-xs! 2xl:text-base!"
        content="account.statement.expenses"
        size="w-full h-10!"
        iconLeft={
          <CurrencyDollarIcon className="fill-current text-neutral-800 w-6 h-6 " />
        }
      />

      <Dialog
        openModal={openModal}
        handleClose={() => (openModal.value = false)}
      >
        {expensesLayout ? (
          <BoardTable layout={expensesLayout} />
        ) : hasStatement ? (
          <p>No hay gastos registrados en este estado de cuenta</p>
        ) : (
          <p>No hay estados de cuenta abiertos con diario de efectivo</p>
        )}
      </Dialog>
    </div>
  );
};

export default ViewExpenses;
